import { Bestnode, Layers, Panning, Zooming } from '@3ddv/ngx-sites-builder-lib';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AvailabilityComponent } from '../../sb-editor-tools/availability/availability.component';
import { Availability } from '../../sb-editor-tools/availability/models/availability.model';
import { BestnodeComponent } from '../../sb-editor-tools/bestnode/bestnode.component';
import { ColormapComponent } from '../../sb-editor-tools/colormap/colormap.component';
import { Colormap } from '../../sb-editor-tools/colormap/models/colormap.model';
import { MinimapComponent } from '../../sb-editor-tools/minimap/minimap.component';
import { Minimap } from '../../sb-editor-tools/minimap/models/minimap.model';
import { PanningComponent } from '../../sb-editor-tools/panning/panning.component';
import { ToolsService } from '../../sb-editor-tools/services/tools.service';
import { ZoomingComponent } from '../../sb-editor-tools/zooming/zooming.component';
import { LabelsComponent } from '../../sb-editor-tools/labels/labels.component';
import { LayersComponent } from '../../sb-editor-tools/layers/layers.component';
import { SblibService } from '../../services/sblib.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  private toolgroup: {
    colormap: Colormap;
    availability: Availability;
    bestnode: Bestnode;
    zooming: Zooming;
    panning: Panning;
    labels: Panning;
    minimap: Minimap;
    layers: Layers;
  };
  public tabs = {
    active: 'look',
  };

  public workflow: any;

  public colorTool;
  public avaTool;
  public minimapTool;
  public panningTool;
  public zoomingTool;
  public labelsTool;
  public bnTool;
  public layersTool;

  @ViewChild('colormap', { static: false }) colormapComponent: ColormapComponent;
  @ViewChild('availability', { static: false }) availabilityComponent: AvailabilityComponent;
  @ViewChild('minimap', { static: false }) minimapComponent: MinimapComponent;
  @ViewChild('panning', { static: false }) panningComponent: PanningComponent;
  @ViewChild('zooming', { static: false }) zoomingComponent: ZoomingComponent;
  @ViewChild('labels', { static: false }) labelsComponent: LabelsComponent;
  @ViewChild('bestnode', { static: false }) bestnodeComponent: BestnodeComponent;
  @ViewChild('layers', { static: false }) layersComponent: LayersComponent;

  constructor(
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.subscriptions = [];
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.colormap) {
        this.colorTool = true;
      } else {
        this.colorTool = false;
      }

      if (res.availability) {
        this.avaTool = true;
      } else {
        this.avaTool = false;
      }

      if (res.minimap) {
        this.minimapTool = true;
      } else {
        this.minimapTool = false;
      }

      if (res.panning) {
        this.panningTool = true;
      } else {
        this.panningTool = false;
      }

      if (res.zooming) {
        this.zoomingTool = true;
      } else {
        this.zoomingTool = false;
      }

      if (res.bestnode) {
        this.bnTool = true;
      } else {
        this.bnTool = false;
      }

      if (res.labels) {
        this.labelsTool = true;
      } else {
        this.labelsTool = false;
      }

      if (res.minimap) {
        this.minimapTool = true;
      } else {
        this.minimapTool = false;
      }

      if (res.layers) {
        this.layersTool = true;
      } else {
        this.layersTool = false;
      }

      this.toolgroup = {
        colormap: Object.assign({}, res.colormap),
        availability: Object.assign({}, res.availability),
        bestnode: Object.assign({}, res.bestnode),
        zooming: Object.assign({}, res.zooming),
        panning: Object.assign({}, res.panning),
        labels: Object.assign({}, res.labels),
        minimap: Object.assign({}, res.minimap),
        layers: Object.assign({}, res.layers),
      };
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public save() {
    // console.log('Tab: ', this.tabs);
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (this.tabs.active === 'look') {
        res.colormap = Object.assign({}, this.colormapComponent.getTool());
      }

      if (this.tabs.active === 'layers') {
        res.layers = Object.assign({}, this.layersComponent.getTool());
      }
      
      if (this.tabs.active === 'plugins') {
        res.bestnode = Object.assign({}, this.bestnodeComponent.getTool());
        res.zooming = Object.assign({}, this.zoomingComponent.getTool());
        res.panning = Object.assign({}, this.panningComponent.getTool());
      }

      if (this.tabs.active === 'minimap') {
        res.minimap = Object.assign({}, this.minimapComponent.getTool());
      }

      if (this.tabs.active === 'availability') {
        res.availability = Object.assign({}, this.availabilityComponent.getTool());
      }

      // console.log('Res: ', res);
      this.sblibService.apply(res);
      this.toastrService.success('', 'Changes applied');
    });
    this.subscriptions.push(tools$);
  }

  public getTool(tool, toolkey: string) {
    this.toolgroup[toolkey] = JSON.parse(JSON.stringify(tool));
  }

  public toggleTab(tab: string) {
    this.availabilityComponent.manualAvailability = false;
    this.availabilityComponent.onSelectManual();
    this.tabs.active = tab;
  }
}
